export default __webpack_public_path__ + "static/media/wait-green.38ad86e4.svg";